import { Route } from '@angular/compiler/src/core';
import {  NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { BackRedirectorComponent } from './components/back-redirector/back-redirector.component';
import { GalleryComponent } from './modules/common-shared-module/components/gallery/gallery.component';
import { HomeComponent } from './pages/home/home.component';
import { ProfileGuard } from './modules/common-shared-module/guards/profile.guard';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

let backURLMatcher: UrlMatcher = (segments: UrlSegment[], group: UrlSegmentGroup, route: Route): UrlMatchResult | null => {
  console.log("Segments => " + segments)
  return segments.length > 0 && segments[0].path == 'webstbk' ? ({ consumed: segments }) : null;

}


const routes: Routes = [
  
  {path: '', redirectTo: '/home/catproc/public-home', pathMatch: 'full' },
  {path: 'redirect', component: RedirectComponent },
  {path: 'bookmarks', redirectTo: '/home/catproc/public-catalog/public-catalog-bookmarks', pathMatch: 'full'},
  {
    path: "home", component: HomeComponent,
    children: [
      {path: '', redirectTo: '/home/catproc/public-home', pathMatch: 'full'},
      { path: 'myaccount', loadChildren: () => import('./modules/my-account-module/my-account.module').then(m => m.MyAccountModule) },
      { path: 'catproc', loadChildren: () => import('./modules/procedure-module/procedure.module').then(m => m.ProcedureModule) },
    ],
  },
  { path: "configens", loadChildren: () => import('./modules/ens-admin-module/ens-admin.module').then(m => m.EnsAdminModule), canActivate: [ProfileGuard] },
  { path: 'eacadmin', loadChildren: () => import('./modules/eac-admin-module/eac-admin.module').then(m => m.EacAdminModule), canActivate: [ProfileGuard] },
  { path: "print", redirectTo: '/fullscreen/form-print', pathMatch: 'full' },
  {
    matcher: backURLMatcher, resolve: { url: 'backRedirector' }, component: BackRedirectorComponent
  },
  {
      path: "fullscreen", children: [
        { path: 'form-print', loadChildren: () => import('./modules/procedure-module/procedure.module').then(m => m.ProcedureModule) },
      ] ,
  },
  { path: 'cross', loadChildren: () => import('./modules/cross-admin-module/cross-admin.module').then(m => m.CrossAdminModule), canActivate: [ProfileGuard] },
  { path: 'aocadmin', loadChildren: () => import('./modules/aoc-admin-module/aoc-admin.module').then(m => m.AocAdminModule), canActivate: [ProfileGuard] },
  { path: "popupensadmin", loadChildren: () => import('./modules/ens-admin-module/ens-admin.module').then(m => m.EnsAdminModule), outlet:"popup" },  
  // MUST be the last route: any URL that doesn't match the routes above shows the 404 page
  { path: '**', component: NotFoundComponent, data: { notFound: true } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
